var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketDecIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2.51534,
    fill: "#04D6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9985 10.003H4.99775C4.45011 10.003 4 9.55289 4 8.99775C4 8.45011 4.45011 8 4.99775 8H7.9985H10.0015H13.0023C13.5574 8 14 8.45011 14 8.99775C14 9.55289 13.5499 9.9955 13.0023 9.9955H10.0015H7.9985V10.003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDecIcon);
export default __webpack_public_path__ + "static/media/TicketDecIcon.6ed87a55e0c262a2c7ac454480bb27c6.svg";
export { ForwardRef as ReactComponent };